import { render, staticRenderFns } from "./EducationalJoiningApplicationForm.vue?vue&type=template&id=3fdf8e60&"
import script from "./EducationalJoiningApplicationForm.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports